import { SymEncryptionKey, symDecrypt, loadSymEncryptedBlob } from 'vault-crypto';

import { ProtectedValue } from '../vaultContent';

export default function unprotect(protectedSecret: SymEncryptionKey, value: ProtectedValue) {
  const decoder = new TextDecoder();
  return decoder.decode(symDecrypt(protectedSecret, loadSymEncryptedBlob(value.encrypted)));
}
